export default {
    common: {
        email: 'Email',
        LoginBtn: 'Login',
        SignUpBtn: 'Sign up',
        SubmitBtn: 'Submit',
        ExitBtn: 'Exit',
        LogoutBtn: 'Logout'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Please check your email for the verification code.',
        VerificationCode: 'Verification code'
    },
    header: {
        OrderHistory: 'Order history',
        MYACCOUNT: 'MY ACCOUNT',
        WelcomeBack: 'Welcome back'
    },
    detail: {
        TotalOrders: 'Orders',
        TotalProducts: 'Products',
        WonderlandPoints: 'Wonderland Points',
        APMCredits: 'APM Credits',
        ExpireOn: 'Expire on',
        NoAPMCredits: 'No APM credits',
        CreditsLoading: 'Credits loading',
        Orders: 'Order',
        Online: 'Online',
        Boutique: 'Boutique',
        Total: 'Total',
        Delivered: 'Delivered',
        NoData: 'No Data',
        Status: 'Status',
        item: 'item',
        items: 'items'
    },
    panel: {},
    entry: {
        Client: 'Customer',
        OrderDate: 'Order Date',
        DeliverDate: 'Delivery Date',
        Description: 'Description',
        Total: 'Total'
    },
    board: {
        Order: 'ORDER',
        Date: 'DATE',
        Total: 'TOTAL'
    },
    order: {
        OrderID: 'Order ID',
        PurchasePlace: 'Location',
        PurchaseDate: 'Purchase date',
        TotalPrice: 'Total Price',
    },
    product: {
        Name: 'Name',
        SKU: 'SKU',
        Size: 'Size',
        Quantity: 'Quantity',
        Price: 'Price',
        WarrantyUntil: 'Warranty Until',
    },
    ordersLayout: {
        pageTitleOrders: 'Orders',
        wonderlandPointsBrand: 'WONDERLAND POINTS',
        navHomepage: 'Homepage',
        navProfile: 'Profile',
        navOrders: 'Orders',
        navWonderland: 'Wonderland',
        navWishlist: 'Wishlist',
        navContactUs: 'Contact Us',
        navExchangeReturn: 'Exchange & Return',
        footerExchangePolicy: 'Exchange and Return policy',
        footerShipping: 'Shipping',
        footerPrivacy: 'Privacy policy',
        footerTerms: 'Terms of service',
        footerRegion: 'France',
        menuTrackOrder: 'Track order',
        menuViewDetails: 'View details',
        back: "Back",
        orderNumberHeading: 'Order Number {{id}}',
        itemsCount_one: '{{count}} item',
        itemsCount_other: '{{count}} items',
        emptyOrders: "You don't have any orders yet.",
        loading: "Loading",
        invoiceSoon: 'Coming soon',
        storeAddressPending: 'Address will be available soon',
        skuPrefix: 'SKU',
        statusLabel: 'Status',
        tabOnline: 'Online',
        tabOffline: 'Offline',
        learnMore: 'LEARN MORE',
        redeemInStore: 'REDEEM IN STORE',
        dateLabel: 'Date',
        itemSingular: 'item',
        statusConfirmed: 'Confirmed',
        purchaseDateLabel: 'Purchase Date:',
        monthJan: 'Jan',
        monthFeb: 'Feb',
        monthMar: 'Mar',
        monthApr: 'Apr',
        monthMay: 'May',
        monthJun: 'Jun',
        monthJul: 'Jul',
        monthAug: 'Aug',
        monthSep: 'Sep',
        monthOct: 'Oct',
        monthNov: 'Nov',
        monthDec: 'Dec',
        storeLabel: "Store",
        downloadInvoice: 'Download Invoice',
        warrantyExpires: 'Warranty expires',
        sizeLabel: 'Size',
        subtotalLabel: 'Subtotal',
        totalLabel: "Total",
        productNameFallback: 'Product',
        ecListTitle: "Your orders",
        ecStatusInStore: "Status: in-store purchase",
        ecOrderNumber: "Order number: {{order_number}}",
        ecDateStore: "{{date}} · {{store_name}}",
        ecCountTotalOne: "{{count}} item: total {{amount}}",
        ecCountTotalOther: "{{count}} items: total {{amount}}",
        ecViewOrder: "View order >",
        ecViewOrderA11y: "View order {{order_number}}",
        ecBackToOrders: "Back to your orders",
        ecInStoreDate: "In-store purchase – {{date}}",
        ecProductsOne: "Product",
        ecProductsOther: "Products",
        ecSku: "Ref. {{sku}}",
        ecQty: "Quantity: {{qty}}",
        ecWarrantyExpired: "Out of warranty",
        ecWarrantyActive: "Under warranty",
        ecSubtotalOne: "Subtotal – {{count}} item",
        ecSubtotalOther: "Subtotal – {{count}} items",
    }
}



// WEBPACK FOOTER //
// ./src/locales/en/index.js